import { Copy, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { formatCnpj } from "@/lib/format";
import { LINK_CONSULTA_CNES, linkConsultaAnvisa } from "./schema";

/** "Anvisa" (abre a consulta já filtrada) + copiar CNPJ, para quando o link direto falhar. */
export function ConsultaAnvisa({ cnpj }: { cnpj: string }) {
  return (
    <>
      <Button variant="ghost" size="sm" asChild>
        <a href={linkConsultaAnvisa(cnpj)} target="_blank" rel="noreferrer">
          Anvisa <ExternalLink className="ml-1 h-3 w-3" aria-hidden />
        </a>
      </Button>
      <BotaoCopiar valor={cnpj} rotulo="CNPJ" exibicao={formatCnpj(cnpj)} />
    </>
  );
}

/** "CNES" (abre a consulta do DATASUS) + copiar o código, que a consulta não recebe pela URL. */
export function ConsultaCnes({ cnes }: { cnes: string }) {
  return (
    <>
      <Button variant="ghost" size="sm" asChild>
        <a href={LINK_CONSULTA_CNES} target="_blank" rel="noreferrer">
          CNES <ExternalLink className="ml-1 h-3 w-3" aria-hidden />
        </a>
      </Button>
      <BotaoCopiar valor={cnes} rotulo="CNES" exibicao={cnes} />
    </>
  );
}

/** Consulta do estabelecimento: Anvisa pelo CNPJ ou, sem CNPJ, DATASUS pelo CNES. */
export function ConsultaEstabelecimento({ cnpj, cnes }: { cnpj?: string; cnes?: string }) {
  if (cnpj) return <ConsultaAnvisa cnpj={cnpj} />;
  return cnes ? <ConsultaCnes cnes={cnes} /> : null;
}

function BotaoCopiar({ valor, rotulo, exibicao }: { valor: string; rotulo: string; exibicao: string }) {
  async function copiar() {
    try {
      await navigator.clipboard.writeText(valor);
      toast.success(`${rotulo} copiado.`);
    } catch {
      toast.error(`Não foi possível copiar o ${rotulo}.`);
    }
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-8 w-8"
      onClick={() => void copiar()}
      aria-label={`Copiar ${rotulo} ${exibicao}`}
      title={`Copiar ${rotulo}`}
    >
      <Copy className="h-4 w-4" />
    </Button>
  );
}
